import InvitationCenter from "./invitation-center";

const INVITATION_CENTER_PATH = "/invitation-center";

export { InvitationCenter, INVITATION_CENTER_PATH };
